import { message } from '@/components';
import { useIntl } from 'umi';

export interface RecordingRejectResp {
  treatment: number;
}

export default function useRecordingReject() {
  const { formatMessage } = useIntl();

  const change = (body: RecordingRejectResp) => {
    const { treatment } = body;
    if (treatment === 2) {
      message.info({
        content: formatMessage({ id: 'REJECT_RECORDING' }),
        noIcon: true,
      });
    }
  };

  return change;
}
